<template>
  <div>
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <!-- <v-container class="form-container elevation-1"> -->
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap align-center justify-center>

        <!-- ----------------------------image ------------------------------------- -->

        <v-flex xs12 md6 sm6 class="arun">
            <!-- <h3 class="primary--text padding-h1"> Image no. 1 </h3>
            <br/>
            <img :src=this.src.src1 height = "100px" width="100px"  class="padding">
        <input type="file" @change="onFileSelected1"  class="padding">
        <br/>
        <v-btn @click="save1()" class="padding" outline flat color="#c30e2e">Upload image 1</v-btn> -->
        <v-card style="background-image: linear-gradient(-150deg, #e8f5e9, #e3f2fd);">
          <v-container>
              <h4 style="text-align:center">Theme Image</h4>

          <img style="border-radius:0%;background-color:white" :src=this.src.src width="100%" height="250px" />

        
          <input type="file" ref="myFile" @change="selectedFile"  class="padding" accept="image/*">
           <v-btn v-if="imageError == ''" @click="save()" style="text-align:right" small color="primary">Upload image</v-btn>
        </v-container>
        <div>
            <h6 v-if="imagelink != null">Image Size : {{image.size}}</h6>
            <h6 class="red--text">{{imageError}}</h6>
        </div>
      </v-card>
        </v-flex>

        


        </v-layout>
      </v-form>
    <!-- </v-container> -->
  </div>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      title: "Theme Image",
      entries: [],
      isLoading: false,
      model: null,
      search: null,

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Tour Theme",
          disabled: false,
          to: "/tourTheme"
        },
        {
          text: "Theme Image",
          disabled: true,
          to: "/imageTourTheme"
        }
      ],

      imagelink: null,
      imageError:'',

      //selectedFile: null,

      valid: true,

      image:{
      size:'',
      height:'',
      width:''
    },
    imageLoaded:false,
      
      src: {
        src: config.API + "ThemeUpload/" + this.$route.params.id
      }
    };
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
    
    /* getImage() {
       this.axios
      .get(config.API + `ProductImage/${this.$route.params.id}`, {
      })
      .then(res => {
        this.src.src = res.data.src;
        this.$Progress.finish();
        this.getImage();
      })
      .catch(err => {
        console.log(err.message);
      });
    }, */

//========================================= Image ===========================================================

    selectedFile() {
      this.imageLoaded = false;
      this.imageError = '';

      let file = this.$refs.myFile.files[0];
      this.imagelink = file;
      if(!file || file.type.indexOf('image/') !== 0) return;
      
      this.image.size = file.size;

      if(this.image.size > 500000) {
        this.imageError = `The image size (${this.image.size}) is too much (max is 500 KB).`;
        return;
      }
      
      let reader = new FileReader();
      
      reader.readAsDataURL(file);
      reader.onload = evt => {
        let img = new Image();
        img.onload = () => {
          this.image.width = img.width;
          this.image.height = img.height;
          this.imageLoaded = true;
        }
        img.src = evt.target.result;
      }

      reader.onerror = evt => {
        console.error(evt);
      }
    },

    save() {
      const fd = new FormData();
      fd.append("image", this.imagelink, this.imagelink.name);
      this.axios
        .post(config.API + `ThemeUpload/${this.$route.params.id}`, fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          //this.$toaster.success("Image 1 added successfully");
          window.location.reload();
        })
        .catch(err => {
          this.$toaster.error(err.message);
        });
    },
    
  },

  mounted() {
    /* this.getImage(); */
    this.$Progress.start();
  }
};
</script>

<style>
#fileInput {
  display: none;
}
.uploader {
  cursor: pointer;
  border-radius: 6px;
  border: 2px solid #bdbdbd;
}
/* .arun {
  max-width: 22% !important;
  margin: 10px;
  border: 1px solid red;
} */

</style>
